var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContinuousSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.309 18.4261L7.5359 15.852V17.2441C4.43401 16.4575 2.1356 13.6848 2.1356 10.3945C2.1356 6.92985 4.68376 4.03921 8.03515 3.43684L7.10575 2.57419L8.52506 1.25684C7.55065 1.33864 6.60355 1.56883 5.70022 1.94427C4.5887 2.40623 3.59069 3.06745 2.73384 3.90931C1.877 4.7513 1.20423 5.732 0.734124 6.82424C0.246921 7.95563 0 9.15674 0 10.3945C0 11.6322 0.246921 12.8333 0.733878 13.9647C1.20399 15.0569 1.87687 16.0376 2.7336 16.8796C3.59044 17.7216 4.58846 18.3827 5.69997 18.8447C6.29453 19.0918 6.90802 19.2758 7.53577 19.3962V21L10.3088 18.426L10.309 18.4261Z",
    fill: "#1FA0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9327 6.8241C17.4626 5.73186 16.7897 4.75116 15.933 3.90917C15.0761 3.06718 14.0781 2.40609 12.9666 1.94413C12.343 1.68494 11.6985 1.49511 11.0387 1.37548V0L8.26562 2.57405L11.0387 5.1481V3.52201C14.1872 4.27651 16.5311 7.07145 16.5311 10.3943C16.5311 13.9523 13.8437 16.905 10.3588 17.3956L11.4688 18.4259L10.2921 19.5182C11.2137 19.4261 12.1098 19.2007 12.9666 18.8446C14.0781 18.3827 15.0761 17.7215 15.933 16.8796C16.7898 16.0376 17.4626 15.0569 17.9327 13.9647C18.4196 12.8333 18.6666 11.6321 18.6666 10.3944C18.6666 9.15685 18.4196 7.95561 17.9327 6.82422V6.8241Z",
    fill: "#1FA0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuousSync);
export default __webpack_public_path__ + "static/media/continuousSync.69a6d2e65cac24957ffd30b38ac9581d.svg";
export { ForwardRef as ReactComponent };